import { Button } from '@monorepo/shared/componentsV2/Button';
import TrashIcon from '@svg/trash.svg';
import React, { useCallback } from 'react';
import { useForm } from 'react-final-form';
import { EMPTY_CONDITIONAL_RULE } from './consts';
import { useIsEmptyState } from './isEmptyHelpers';

interface ClearAllConditionalRulesButtonProps {
  moveFocusToAddRuleButton: () => void;
}

export function ClearAllConditionalRulesButton({
  moveFocusToAddRuleButton,
}: ClearAllConditionalRulesButtonProps) {
  const { change, getRegisteredFields, resetFieldState } = useForm();
  const isEmptyState = useIsEmptyState();

  const onClearAllRules = useCallback(() => {
    change('conditionalRules', [EMPTY_CONDITIONAL_RULE]);
    moveFocusToAddRuleButton();

    // clear error states
    const registeredFields = getRegisteredFields();
    registeredFields.forEach(resetFieldState);
  }, [change, getRegisteredFields, moveFocusToAddRuleButton, resetFieldState]);

  return (
    <Button color="secondary" onClick={onClearAllRules} disabled={isEmptyState}>
      <TrashIcon aria-hidden />
      Delete all rules
    </Button>
  );
}
